import ApiService from "@/core/services/ApiService";
import axios, { AxiosError } from "axios";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { BackendError } from "../models";

interface Email {
  asunto: string;
  mensaje: string;
  targetType: string;
  targetId: string;
}

@Module({ namespaced: true, name: "EmailsModule" })
export class EmailsModule extends VuexModule {
  email: Email | null = null;
  errors: BackendError | null = null;

  @Action({ rawError: true })
  enviar(email: Partial<Email>) {
    this.clearErrors();

    return ApiService.post("/email", email).catch((err: Error | AxiosError) => {
      if (axios.isAxiosError(err)) {
        if (err.response && err.response.status === 422) {
          this.setError(err.response.data);
        } else if (err.response && err.response.data) {
          this.setError(err.response.data);
        } else {
          const axiosError = { error: err };
          this.setError(axiosError);
        }
      } else {
        const generalError = { error: err };
        this.setError(generalError);
      }
      throw err;
    });
  }

  @Mutation
  clearErrors() {
    this.errors = null;
  }

  @Mutation
  setError(error) {
    this.errors = error;
  }
}
